import React, { useEffect } from "react";
import AOS from "aos";
import "./About.css";

export default function About() {
  useEffect(() => {
    AOS.init({ duration: 800, offset: 100 });
  }, []);

  return (
    <section id="about" className="about-section">
      <div className="container">
        {/* Section Header */}
        <div className="section-header text-center mb-5" data-aos="fade-up">
          <h2 className="section-title">
            About <span className="highlight">MZR Software</span>
          </h2>
          <p className="section-subtitle">
            13+ Years of Excellence in Custom Software Development
          </p>
          <p className="company-fullname">
            <strong>Muhammad Zeeshan Rashid Software</strong> | Founded 2018 |
            NTN Registered
          </p>
        </div>

        {/* Founder Section */}
        <div className="founder-section mb-5" data-aos="fade-up">
          <div className="row align-items-center g-4">
            <div className="col-md-6" data-aos="fade-right">
              <div className="founder-card">
                <h3 className="founder-title">👨‍💼 Meet the Founder</h3>
                <h4 className="founder-name">Shaikh Muhammad Zeeshan Rashid</h4>
                <p className="founder-title-text">
                  Founder & Lead Software Architect
                </p>
                <p className="founder-bio">
                  With 13+ years of experience in software development, I
                  founded MZR Software in 2018 with a vision to deliver
                  world-class custom software solutions. The company has since
                  grown to serve 300+ happy clients across various industries.
                </p>
                <p className="founder-bio">
                  Passionate about creating innovative, scalable, and robust
                  solutions that transform businesses and drive meaningful
                  growth.
                </p>
              </div>
            </div>
            <div className="col-md-6" data-aos="fade-left">
              <div className="company-journey">
                <h3 className="journey-title">📍 Our Journey</h3>
                <div className="timeline-item">
                  <div className="timeline-year">2018</div>
                  <div className="timeline-content">
                    <h5>Company Founded & NTN Registered</h5>
                    <p>
                      Began our mission to deliver exceptional software
                      solutions with a focus on quality and innovation.
                    </p>
                  </div>
                </div>
                <div className="timeline-item">
                  <div className="timeline-year">2018-2024</div>
                  <div className="timeline-content">
                    <h5>Rapid Growth & Expansion</h5>
                    <p>
                      Served 300+ clients, completed 500+ successful projects,
                      and built a team of expert developers.
                    </p>
                  </div>
                </div>
                <div className="timeline-item">
                  <div className="timeline-year">2024+</div>
                  <div className="timeline-content">
                    <h5>Continuous Innovation</h5>
                    <p>
                      Expanding into emerging technologies like AI/ML, Cloud
                      Architecture, and DevOps solutions.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* About Cards */}
        <div className="row g-4 mb-5">
          <div
            className="col-md-6 col-lg-4"
            data-aos="flip-left"
            data-aos-delay="100"
          >
            <div className="about-card">
              <div className="card-icon">💡</div>
              <h4>Our Mission</h4>
              <p>
                Delivering innovative, scalable software solutions that
                transform businesses and drive sustainable growth.
              </p>
            </div>
          </div>

          <div
            className="col-md-6 col-lg-4"
            data-aos="flip-left"
            data-aos-delay="150"
          >
            <div className="about-card">
              <div className="card-icon">⭐</div>
              <h4>Why Choose Us?</h4>
              <p>
                13+ years of expertise, custom solutions, 300+ happy clients,
                and 98% satisfaction rate. Your success is our priority.
              </p>
            </div>
          </div>

          <div
            className="col-md-6 col-lg-4"
            data-aos="flip-left"
            data-aos-delay="200"
          >
            <div className="about-card">
              <div className="card-icon">🚀</div>
              <h4>Our Values</h4>
              <p>
                Quality-first approach, transparent communication, continuous
                innovation, and client-centric development.
              </p>
            </div>
          </div>
        </div>

        {/* Expertise Section */}
        <div className="expertise-section" data-aos="fade-up">
          <div className="row g-4 align-items-center">
            <div className="col-md-6">
              <h3 className="expertise-title mb-4">Expertise & Capabilities</h3>
              <div className="expertise-list">
                <div className="expertise-item">
                  <span className="checkmark">✓</span>
                  <span>Custom Enterprise Software Development</span>
                </div>
                <div className="expertise-item">
                  <span className="checkmark">✓</span>
                  <span>POS & ERP Systems</span>
                </div>
                <div className="expertise-item">
                  <span className="checkmark">✓</span>
                  <span>Cloud & DevOps Solutions</span>
                </div>
                <div className="expertise-item">
                  <span className="checkmark">✓</span>
                  <span>Full-Stack Development</span>
                </div>
                <div className="expertise-item">
                  <span className="checkmark">✓</span>
                  <span>Mobile App Development</span>
                </div>
                <div className="expertise-item">
                  <span className="checkmark">✓</span>
                  <span>AI & Machine Learning Solutions</span>
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="stats-grid">
                <div className="stat-box">
                  <span className="stat-number">500+</span>
                  <span className="stat-label">Projects Completed</span>
                </div>
                <div className="stat-box">
                  <span className="stat-number">300+</span>
                  <span className="stat-label">Happy Clients</span>
                </div>
                <div className="stat-box">
                  <span className="stat-number">13+</span>
                  <span className="stat-label">Years Experience</span>
                </div>
                <div className="stat-box">
                  <span className="stat-number">98%</span>
                  <span className="stat-label">Client Satisfaction</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
